import {
  Accordion,
  Body,
  Breadcrumb,
  BreadcrumbGroup,
  ButtonToggle,
  Checkbox,
  CheckboxGroup,
  ContentAlignment,
  FilterLayout,
  Image,
  ImageEnhancements,
  ImageOverlay,
  Layout,
  LayoutWrapper,
  LinkNavigation,
  LinkNavigationGroup,
  Modal,
  RadioGroup,
  Radio,
  Spacer,
  StylingGrid,
  Tab,
  TabGroup,
  TagFilter,
  TagFilterGroup,
  TemplateILP,
  Tile,
  Title,
  UtilityBar,
  ButtonLayout,
  Button,
  LoadingIndicator,
  GutterContainer,
  HeaderPage,
  Caption,
  StickyContainer,
  Carousel,
  CollectionList,
  Display,
  FlagText,
  ItemTag,
  ItemTags,
  Keyline,
  MediaObject,
  Price,
  StyleUserInfo,
  TemplateMediaInformation,
  Footer,
  ButtonIcon,
  Drawer,
  LinkCell,
  LinkImage,
  NavigationHeader,
  ButtonFloating,
  LinkText,
  TemplateFullGutter,
  CmsLink,
  CmsImage,
  ProductTile
} from "uq-global-ec-uikit/components/react";

export const UQUikit = {
  Accordion,
  Body,
  Breadcrumb,
  BreadcrumbGroup,
  Button,
  ButtonFloating,
  ButtonIcon,
  ButtonLayout,
  ButtonToggle,
  Caption,
  Carousel,
  Checkbox,
  CheckboxGroup,
  CmsImage,
  CmsLink,
  CollectionList,
  ContentAlignment,
  Display,
  Drawer,
  FilterLayout,
  FlagText,
  Footer,
  GutterContainer,
  HeaderPage,
  Image,
  ImageEnhancements,
  ImageOverlay,
  ItemTag,
  ItemTags,
  Keyline,
  Layout,
  LayoutWrapper,
  LinkCell,
  LinkImage,
  LinkNavigation,
  LinkNavigationGroup,
  LinkText,
  LoadingIndicator,
  MediaObject,
  Modal,
  NavigationHeader,
  Price,
  Radio,
  RadioGroup,
  Spacer,
  StickyContainer,
  StylingGrid,
  StyleUserInfo,
  Tab,
  TabGroup,
  TagFilter,
  TagFilterGroup,
  TemplateFullGutter,
  TemplateILP,
  TemplateMediaInformation,
  Tile,
  Title,
  UtilityBar,
  ProductTile
};
